import React from 'react';

// Styles
import './SurfaceItemName.scss';

// Helpers
import { getSurfaceItemTrackingProperties } from 'Shared/helpers';

// Components
import WpTextTruncate from 'Wpds/components/text-truncate/WpTextTruncate';

// Hooks
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

type Props = {
  surfaceItem;
};

const SurfaceItemName = ({ surfaceItem }: Props) => {
  const { workspace } = useWorkspace();
  const trackLinkClick = () => {
    const trackingProps = getSurfaceItemTrackingProperties({
      surfaceItem,
      type: null,
      workspace,
      linkClickEvent: true,
    });
    (window as any).analytics.track('Clicked Surface External Link', trackingProps);
  };
  return (
    <a
      href={surfaceItem.external_link}
      onClick={trackLinkClick}
      target="_blank"
      rel="noreferrer"
      className="SurfaceItemName"
    >
      <WpTextTruncate text={surfaceItem.name} />
    </a>
  );
};

export default SurfaceItemName;
